module.exports = __webpack_public_path__ + "img/image71.e2e5b799.jpg";